import { useMutation } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";
import { CourtTemporaryBlockadeDto } from "../../../models/court/dto/court-temporary-blockade.dto";
import { CreateCourtBlockadeDto } from "../../../models/court/dto/create-court-blockade.dto";

export const useCreateCourtBlockade = (onSuccess: (data: CourtTemporaryBlockadeDto) => void) => {
    const apiClient = useApiClient();
    const toast = useToast();
    return useMutation({
        mutationKey: ['createCourtBlockade'],
        mutationFn: (body: CreateCourtBlockadeDto) => apiClient.fetchApi<CourtTemporaryBlockadeDto, CreateCourtBlockadeDto>({ method: 'POST', endpoint: `courts/${body.courtId}/blockade`, body }),
        onSuccess: (data) => {
            onSuccess(data);
        },
        onError: () => {
            toast({ title: translate('error'), status: 'error', duration: 3000, position: 'top-right' });
        }
    });
};